import { Container } from '@goldbely/explore-component-library';
import React, { useState, FC } from 'react';
import clsx from 'classnames';

import { useEscape } from 'src/explore/hooks/useEscape';
import { IMerchant, INavItem } from 'src/prize/types/shoppe';

import MobileMenuToggle from '../../../../atoms/MobileMenuToggle';
import Logo from './atoms/Logo';
import Buttons from './molecules/Buttons';
import Navigation from './molecules/Navigation';

import styles from './index.module.sass';

interface AragostaProps {
  className?: {
    container?: string;
  };
  links?: INavItem;
  // The width the logo is requested from imgix at. Raise it for a wide wordmark
  // that the tenant also widens in CSS, or the mark is upscaled and blurs.
  logoWidth?: number;
  merchant: IMerchant;
}

const Aragosta: FC<AragostaProps> = ({ className, links, logoWidth, merchant }) => {
  const [ isMobileMenuActive, setIsMobileMenuActive ] = useState( false );

  const handleToggleMobileMenu = () => {
    setIsMobileMenuActive( !isMobileMenuActive );
  };

  useEscape(() => setIsMobileMenuActive( false ));

  return (
    <div className={clsx( styles.wrap, className?.container )}>
      <Container className={styles.container}>
        <MobileMenuToggle
          className={styles.hamburger}
          isActive={isMobileMenuActive}
          onClick={handleToggleMobileMenu}
        />

        <Logo merchant={merchant} width={logoWidth} />

        <Navigation
          isActive={isMobileMenuActive}
          links={links}
          merchant={merchant}
          onClose={handleToggleMobileMenu}
        />

        <Buttons />
      </Container>
    </div>
  );
};

export default Aragosta;
